import { ReactNode } from "react";
import { Link } from "react-router-dom";

interface INavLink {
  to: string;
  children?: ReactNode
}

function NavLink({ to, children }: INavLink) {
  return (
    <Link
      to={to}
      className="transition hover:text-red-800 dark:hover:text-red-800"
    >
      {children}
    </Link>
  )
}

export function Footer() {
  return (
    <footer className="mt-32">
      <div className='sm:px-8'>
        <div className="mx-auto max-w-7xl lg:px-8">
          <div className="border-t border-zinc-100 pt-10 pb-16 dark:border-zinc-700/40">
            <div
              className='relative px-4 sm:px-8 lg:px-12'
            >
              <div className="mx-auto max-w-xl lg:max-w-4xl">
                <div className="flex flex-col items-center justify-between gap-6 sm:flex-row">
                  <div className="flex gap-6 text-sm font-medium text-zinc-800 dark:text-zinc-200">
                    <NavLink to="/about">Quienes somos</NavLink>
                    <NavLink to="/blog">Blog</NavLink>
                    <NavLink to="/product">Productos</NavLink>
                    <NavLink to="/company">Empresa</NavLink>
                  </div>
                  <p className="text-sm dark:text-white text-gray-900">
                    &copy;Copyright {new Date().getFullYear()}. Grupo Aceña. Todos los derechos reservados
                  </p>
                </div></div>
            </div>

          </div>
        </div>
      </div>
    </footer >
  )
}
